import React from "react";
import { DropdownMenuSeparator } from "@radix-ui/react-dropdown-menu";

import Divider from "../divider/Divider";

const Seperator = () => (
  <DropdownMenuSeparator asChild>
    <Divider margin="4px 0" />
  </DropdownMenuSeparator>
);

export default Seperator;
